<script lang="ts" setup>
    const { open = false } = defineProps<{
        open?: boolean
    }>()
</script>

<template>
    <button
        type="button"
        class="relative z-50 border-0 p-0 uppercase transition hover:text-medium"
        :class="{ 'is-open': open }"
    >
        <span class="hidden lg:block">Menu</span>
        <span class="hamburger block lg:hidden">
            <span></span>
            <span></span>
        </span>
    </button>
</template>

<style scoped>
    .hamburger {
        position: relative;
        width: 25px;
        height: 18px;
        cursor: pointer;

        span:before,
        span:after {
            @apply transition;
            @apply rounded-full;
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 2px;
            background-color: currentColor;
        }

        span:first-child:after {
            top: auto;
            bottom: 0;
        }

        span:last-child {
            display: block;
            height: 100%;

            &:before,
            &:after {
                top: 50%;
                transform: translateY(-50%);
            }
        }
    }

    .is-open .hamburger {
        span:first-child {
            &:before,
            &:after {
                opacity: 0;
            }

            &:before {
                transform: translateY(200%);
            }

            &:after {
                transform: translateY(-200%);
            }
        }

        span:last-child {
            &:before {
                transform: rotate(45deg);
            }

            &:after {
                transform: rotate(-45deg);
            }
        }
    }
</style>
